<template>
  <el-collapse-item name="httpd">
    <template slot="title">
      Apache2 Configuration
      <el-tag v-if="auto" type="success" size="small">AUTO</el-tag>
      <el-tag v-else type="warning" size="small">Custom configuration</el-tag>
    </template>

    <el-form label-position="left" label-width="200px">
      <el-row type="flex" :gutter="30">
        <el-col :span="9">
          <el-form-item label="Timeout">
            <el-input
              v-model="form.httpd_timeout"
              type="number"
              min="1"
              controls-position="right"
              size="mini"
              placeholder="Auto"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col class="notice" :span="15">
          Number of seconds before data "sends" or "receives" (to or from the client) times out.
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="30">
        <el-col :span="9">
            <el-form-item label="MinSpareServers">
              <el-input
                v-model="form.httpd_min_spare_servers"
                type="number"
                min="1"
                max="256"
                controls-position="right"
                size="mini"
                placeholder="Auto"
                clearable
              />
            </el-form-item>
        </el-col>

        <el-col class="notice" :span="15">
          Minimum number of process which is not handling a request, but waiting for a new request.
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="30">
        <el-col :span="9">
          <el-form-item label="MaxRequestWorkers">
            <el-input
              v-model="form.httpd_max_request_workers"
              type="number"
              min="1"
              max="256"
              controls-position="right"
              size="mini"
              placeholder="Auto"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col class="notice" :span="15">
          Limit number of simultaneous requests that will be served
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="30">
        <el-col :span="9">
          <el-form-item label="MaxConnectionsPerChild">
            <el-input
              v-model="form.httpd_max_connections_per_child"
              type="number"
              min="0"
              controls-position="right"
              size="mini"
              placeholder="Auto"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col class="notice" :span="15">
          Limit number of connections that a process will handle before die.
          If MaxConnectionsPerChild is 0, then the process will never expire.
        </el-col>
      </el-row>

      <el-button
        type="primary"
        size="small"
        :disabled="!changes"
        @click.prevent="save"
      >
        Save and restart
      </el-button>
    </el-form>
  </el-collapse-item>
</template>

<script>
import config from '../../../../mixins/config'

export default {
  mixins: [config],
  data () {
    return {
      changes: false
    }
  },
  computed: {
    auto () {
      for (const key in this.form) {
        if (key.match(/^httpd/) && this.form[key]) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    save () {
      this.change()
      this.changes = false
    }
  },
  watch: {
    'form.httpd_timeout' (value) {
      this.changes = true
    },
    'form.httpd_min_spare_servers' () {
      this.changes = true
    },
    'form.httpd_max_request_workers' () {
      this.changes = true
    },
    'form.httpd_max_connections_per_child' () {
      this.changes = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../theme";

  .el-input {
    min-width: 90px;
  }
  .el-row {
    padding: 10px 0;
    align-items: center;

    .el-col {
      vertical-align: middle;
    }
    .el-form-item {
      margin: 0;
      font-size: 13px;
      font-weight: 500;
    }
    .notice {
      line-height: 15px;
      padding: 5px 0;
      font-size: 13px;
      color: $--color-text-alt;
    }
    &:nth-child(odd) {
      background-color: $--background-color-base;
    }
  }
</style>
